import * as React from 'react';
import * as _ from 'lodash';
import Chip, {ChipProps} from '@material-ui/core/Chip/Chip';
import {Omit} from 'utility-types';
import EditIcon from '@material-ui/icons/Edit';
import withStyles, {WithStyles} from '@material-ui/core/styles/withStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import {FilterValueType} from '../redux/actions';

export interface TableFilterChipProps extends Omit<ChipProps, 'label'> {
  name: string;
  value?: FilterValueType;
  required?: boolean;
  recommendation?: boolean;
  readonly?: boolean;
}

const styles = theme =>
  createStyles({
    root: {
      margin: theme.spacing(0.5),
    },
  });

class TableFilterChip extends React.PureComponent<TableFilterChipProps & WithStyles<typeof styles>> {
  render() {
    const {
      name,
      value,
      required,
      recommendation,
      readonly,
      classes: {root},
      ...otherProps
    } = this.props;
    let valueText;
    if (value) {
      if (_.isString(value) || _.isNumber(value) || _.isArray(value)) {
        valueText = `: ${value}`;
      } else {
        valueText = ` ${value.operator.toLowerCase()} ${value.value}`;
      }
    }
    if (readonly) {
      delete otherProps.onClick;
    }
    if (required) {
      otherProps.onDelete = otherProps.onClick;
    }
    return (
      <Chip
        className={root}
        variant={recommendation ? 'outlined' : undefined}
        deleteIcon={required ? <EditIcon /> : undefined}
        label={
          <React.Fragment>
            {name}
            {valueText}{' '}
          </React.Fragment>
        }
        color="primary"
        {...otherProps}
      />
    );
  }
}

export default withStyles(styles)(TableFilterChip);
